<template>
  <div :data-time="$store.state.cadastroVet.time" :data-time2="time">
    <template v-for="(item, index) in $store.state.cadastroVet">
      <template v-if="index !== 'time' && [ '', null, undefined ].indexOf($store.state.cadastroVet[index]) === -1">
        <!-- INICIAR REGISTRO DE ATENDIMENTO -->
        <Registro-Atendimento-Iniciar-Atendimento :key="$store.state.cadastroVet[index].tipo + '-' + index" v-if="$store.state.cadastroVet[index].tipo === 'REGISTRO_ATENDIMENTO_INICIAR'"
          :cpntContatoId="$store.state.cadastroVet[index].contatoId"
          :cpntAssuntoId="$store.state.cadastroVet[index].assuntoId"
          :cpntClu="$store.state.cadastroVet[index].clu"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></Registro-Atendimento-Iniciar-Atendimento>

        <!-- VISUALIZAR CADASTRO -->
        <RF-Visualizar-Cadastro :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="[ 'contato', 'veiculo', 'pet' ].indexOf($store.state.cadastroVet[index].tipo) !== -1 && $store.state.cadastroVet[index].editar === false && [ '', null, undefined, '0', 0 ].indexOf($store.state.cadastroVet[index].id) === -1"
          :ref='"rf-app-info" + $store.state.cadastroVet[index].tipo'
          :cpntTipo='$store.state.cadastroVet[index].tipo'
          :cpntRefId='$store.state.cadastroVet[index].id'
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Visualizar-Cadastro>

        <!-- FORMULARIO CONTATO -->
        <App-Contato-Formulario :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'contato'"
          :cpntId='$store.state.cadastroVet[index].id'
          :cpntNomeDig='$store.state.cadastroVet[index].hasOwnProperty("nome") ? $store.state.cadastroVet[index].nome : ""'
          :cpntContatoTpCon='$store.state.cadastroVet[index].hasOwnProperty("tpCon") ? $store.state.cadastroVet[index].tpCon : ""'
          :cpntCadastroRapido='[ "", null, undefined, false, false, "0" ].indexOf($store.state.cadastroVet[index].cadastroRapido) === -1'
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Contato-Formulario>

        <!-- FORMULARIO DE VEICULOS -->
        <App-Veiculo-Formulario :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'veiculo'"
          :cpntId="$store.state.cadastroVet[index].id"
          :cpntNomeDig="$store.state.cadastroVet[index].nome"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Veiculo-Formulario>

        <!-- FORMULARIO DE PET -->
        <App-Pet-Formulario :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'pet'"
          :cpntId="$store.state.cadastroVet[index].id"
          :cpntNomeDig="$store.state.cadastroVet[index].nome"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Pet-Formulario>

        <!-- CADASTRO DE PRODUTO -->
        <RF-Formulario-Produto :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'produto'"
          :cpntNome='[ "", null, undefined ].indexOf($store.state.cadastroVet[index].nome) === -1 ? $store.state.cadastroVet[index].nome : ""'
          :cpntOnUpdateField='$store.state.cadastroVet[index].onUpdateField'

          :cpntId='$store.state.cadastroVet[index].id'
          :cpntDemanda="$store.state.cadastroVet[index].demanda === undefined ? '' : $store.state.cadastroVet[index].demanda.toString()"
          :cpntPDocTp="$store.state.cadastroVet[index].p_doc_tp === undefined ? '' : $store.state.cadastroVet[index].p_doc_tp.toString()"
          :cpntIdCon="$store.state.cadastroVet[index].id_con === undefined ? '' : $store.state.cadastroVet[index].id_con.toString()"
          :cpntIdUf="$store.state.cadastroVet[index].uf === undefined ? '' : $store.state.cadastroVet[index].uf.toString()"
          :cpntVetor="$store.state.cadastroVet[index].vetor"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
          @ALTERAR_ID_PRODUTO="(params) => { abrirCadastrosAlterarIdProduto(index, params) }"
          @ATUALIZAR_INFORMACOES_EXTERNAS="() => { abrirCadastroAtualizarFilhos(index) }"
        ></RF-Formulario-Produto>

        <!-- CADASTRO DE SERVIÇO -->
        <RF-Formulario-Servico :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'servico'"
          :cpntId='$store.state.cadastroVet[index].id'
          :cpntNomeDig='$store.state.cadastroVet[index].hasOwnProperty("nome") ? $store.state.cadastroVet[index].nome : ""'
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Formulario-Servico>

        <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO DE PRODUTO -->
        <RF-Formulario-Sit-Fiscal  :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'servico-sit-fiscal'"
          :cpntId='$store.state.cadastroVet[index].id'
          :cpntOnFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Formulario-Sit-Fiscal>

        <!-- CONTROLE DE PROCESSOS EDITAR -->
        <RF-Formulario-Controle-Processo :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'processo'"
          :cpntId='$store.state.cadastroVet[index].id'
          :cpntTipo='$store.state.cadastroVet[index].modelo'
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Formulario-Controle-Processo>

        <!-- ABRIR FORMULARIO PARA ALTERAR COMISSIONADO -->
        <RF-Formulario-Comssisao :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'comissao'"
          :cpntId='$store.state.cadastroVet[index].id'
          :cpntTipo='$store.state.cadastroVet[index].modelo'
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Formulario-Comssisao>

        <!-- ABRE A TELA PARA REENVIAR A NOTA FISCAL POR E-MAIL -->
        <RF-DF-Reenviar :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'REENVIAR_NOTA'"
          :cpntId="Number($store.state.cadastroVet[index].id)"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-DF-Reenviar>

        <!-- REALIZA A BUSCA DE UM CONTATO -->
        <RF-Buscar-Cadastro :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'BUSCAR_CADASTRO'"
          :cpntTipo="$store.state.cadastroVet[index].tpCadastro"
          :cpntTitulo="$store.state.cadastroVet[index].titulo"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Buscar-Cadastro>

        <!-- REALIZA A BUSCA DE UM CONTATO -->
        <RF-Subase-Gerenciar-Clu :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'GERENCIAR_CLU'"
          :cpntClu="$store.state.cadastroVet[index].params.clu"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Subase-Gerenciar-Clu>

        <!-- REALIZA A BUSCA DE UM CONTATO -->
        <App-Consultar-Historico :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'CONSULTAR_HISTORICO'"
          :cpntFiltros="$store.state.cadastroVet[index].filtros"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Consultar-Historico>

        <!-- REALIZA A BUSCA DE UM CONTATO -->
        <RF-Subase-Gerenciar-Informacoes-Clu :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'DETALHES_LU'"
          :cpntClu="$store.state.cadastroVet[index].clu"
          :cpntTipo="$store.state.cadastroVet[index].pagina"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Subase-Gerenciar-Informacoes-Clu>

        <!-- ABRIR_DOC_FISCAL -->
        <RF-DF-Abrir :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'ABRIR_DOC_FISCAL'"
          :cpntId="Number($store.state.cadastroVet[index].id)"
          :cpntAcao="$store.state.cadastroVet[index].acao"
          :cpntOrigem="$store.state.cadastroVet[index].origem"
          :cpntBuffer="$store.state.cadastroVet[index].buffer"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-DF-Abrir>

        <!-- FINANCEIRO_EDITAR_BOLETO -->
        <RF-Financeiro-Editar-Boleto :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'FINANCEIRO_EDITAR_BOLETO'"
          :cpntIds="$store.state.cadastroVet[index].ids"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Financeiro-Editar-Boleto>

        <!-- SETA A TELA PARA ANEXAR O ARQUIVO -->
        <Armazenamento-Arquivos-Anexar :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'ANEXAR_ARQUIVO'"
          :cpntRefMod="Number($store.state.cadastroVet[index].refMod)"
          :cpntSalvarPosteriormente="$store.state.cadastroVet[index].salvarPosteriormente"
          :cpntRefId="$store.state.cadastroVet[index].refId.toString()"
          :cpntRegTp="$store.state.cadastroVet[index].finTp"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></Armazenamento-Arquivos-Anexar>

        <!-- DETALHES DE CONSUMO DE PRODUTOS -->
        <RF-Venda-Insumo-Consumo :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'VENDA_CONSUMO_INSUMOS'"
          :cpntVendaIds="$store.state.cadastroVet[index].vendaIds"
          :cpntIdVenPro="$store.state.cadastroVet[index].idVenPro"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Venda-Insumo-Consumo>

        <!-- DETALHES DE CONSUMO DE PRODUTOS -->
        <RF-Usuario-Upload-Imagem :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'USUARIO_UPLOAD_IMAGEM'"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Usuario-Upload-Imagem>

        <!-- DEMANDA NOVA -->
        <App-Demanda-Nova :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'DEMANDA_NOVA'"
          :cpntTipo="$store.state.cadastroVet[index].cadastro"
          :cpntDemanda="$store.state.cadastroVet[index].demanda"
          :cpntParamsId="$store.state.cadastroVet[index].paramsId"
          :cpntRedirecionar="$store.state.cadastroVet[index].redirecionar"
          :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Demanda-Nova>

        <!-- COPIAR ITENS PARA OUTRA VENDA -->
        <App-Demanda-Consultar :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'CONSULTAR_DEMANDA'"
        :cpntDemanda="$store.state.cadastroVet[index].demanda"
        :cpntCopiar="$store.state.cadastroVet[index].copiar"
        :cpntTitulo="$store.state.cadastroVet[index].titulo"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Demanda-Consultar>

        <!-- COPIAR ITENS PARA OUTRA VENDA -->
        <App-Contato-Consultar :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'CONSULTAR_CONTATO'"
        :cpntTitulo="$store.state.cadastroVet[index].titulo"
        :cpntTituloExplica="$store.state.cadastroVet[index].tituloExplica"
        :cpntSelecionar="$store.state.cadastroVet[index].selecionar"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Contato-Consultar>

        <!-- COPIAR ITENS PARA OUTRA VENDA -->
        <App-Produto-Consultar :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'CONSULTAR_PRODUTO'"
        :cpntTitulo="$store.state.cadastroVet[index].titulo"
        :cpntSelecionar="$store.state.cadastroVet[index].selecionar"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Produto-Consultar>

        <!-- GERAR ETIQUETA COMPRAS -->
        <RF-Compra-Etiqueta :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'COM_PRO_ABRIR_ETIQUETA'"
        :cpntDemanda="$store.state.cadastroVet[index].demanda"
        :cpntDemandaId="$store.state.cadastroVet[index].demandaId"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></RF-Compra-Etiqueta>


        <!-- TELA PARA BUSCAR DADOS NA API COMO PLACA, CNPJ E OUTROS... -->
        <App-Buscar-Cadastro-Api :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'BUSCAR_CADASTRO_API'"
        :cpntTitulo="$store.state.cadastroVet[index].titulo"
        :cpntRouter="$store.state.cadastroVet[index].router"
        :cpntMethod="$store.state.cadastroVet[index].method"
        :cpntParams="$store.state.cadastroVet[index].params"
        :cpntBuscaComplementar="$store.state.cadastroVet[index].buscaComplementar"
        :cpntMapa="$store.state.cadastroVet[index].mapa"
        :cpntBuscarValor="$store.state.cadastroVet[index].buscarValor"
        :cpntSetarValor="$store.state.cadastroVet[index].setarValor"
        :cpntSilencioso="$store.state.cadastroVet[index].silencioso"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Buscar-Cadastro-Api>

        <!-- SETA O SIMULADOR -->
        <App-Sit-Fiscal-Simulador :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'SIMULADOR_SIT_FISCAL'"
        :cpntDemanda="$store.state.cadastroVet[index].demanda === undefined ? '' : $store.state.cadastroVet[index].demanda.toString()"
        :cpntPDocTp="$store.state.cadastroVet[index].p_doc_tp === undefined ? '' : $store.state.cadastroVet[index].p_doc_tp.toString()"
        :cpntNCM="$store.state.cadastroVet[index].ncm === undefined ? '' : $store.state.cadastroVet[index].ncm.toString()"
        :cpntIdPro="$store.state.cadastroVet[index].id_pro === undefined ? '' : $store.state.cadastroVet[index].id_pro.toString()"
        :cpntIdCon="$store.state.cadastroVet[index].id_con === undefined ? '' : $store.state.cadastroVet[index].id_con.toString()"
        :cpntIdUf="$store.state.cadastroVet[index].id_uf === undefined ? '' : $store.state.cadastroVet[index].id_uf.toString()"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Sit-Fiscal-Simulador>

        <DF-Log :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'LOG_COMUNICACAO'"
        :cpntDfId="Number($store.state.cadastroVet[index].id)"
        :cpntDfLogTipo="'comunicacao'"
        :cpntMostrarBT="$store.state.cadastroVet[index].button"
        :cpntMostrarTab="$store.state.cadastroVet[index].tabela"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></DF-Log>

        <DF-Log :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'LOG_EMAIL'"
        :cpntDfId="Number($store.state.cadastroVet[index].id)"
        :cpntDfLogTipo="'email'"
        :cpntMostrarBT="$store.state.cadastroVet[index].button"
        :cpntMostrarTab="$store.state.cadastroVet[index].tabela"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></DF-Log>

        <App-Etiqueta-Itens :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'GERAR_ETIQUETA'"
        :cpntTipo="$store.state.cadastroVet[index].model"
        :cpntIds="$store.state.cadastroVet[index].ids"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Etiqueta-Itens>

        <App-Conta-Bancaria-Dialog-Conciliados :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'FINANCEIRO_REGISTRO_CONCILIADO'"
        :cpntId="$store.state.cadastroVet[index].id"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Conta-Bancaria-Dialog-Conciliados>

        <!-- TELA PARA CADASTRAR NOVO USUARIO WHTASAPP -->
        <App-Subase-Suporte :key="$store.state.cadastroVet[index].tipo + '-' + index" v-else-if="$store.state.cadastroVet[index].tipo === 'SUBASE_SUPORTE'"
        :cpntFecharFormulario='function (atualizar, id, cadastro) { $store.state.cadastroVet[index].fechar(index, atualizar, id, cadastro) }'
        ></App-Subase-Suporte>

        <!-- IMPRIME NO CONSOLE O DADOS NÃO ENCONTRADO -->
        <template v-else>{{ abrirCadastrosNaoEncontrado(index) }}</template>
      </template>
    </template>
  </div>
</template>

<style>
</style>

<script>
  export default {
    props: {
      cpntQtde: {
        required: false,
        type: Number,
        default: function () {
          return 1
        }
      }
    },
    components: {
      'Registro-Atendimento-Iniciar-Atendimento': () => import('@/components/registro-atendimento/Registro-Atendimento-Iniciar-Atendimento.vue'),
      'RF-Visualizar-Cadastro': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro.vue'),
      'App-Contato-Formulario': () => import('@/components/contato/gerenciar/Contato-Formulario.vue'),
      'App-Veiculo-Formulario': () => import('@/components/veiculo/gerenciar/Veiculo-Formulario.vue'),
      'App-Pet-Formulario': () => import('@/components/pet/gerenciar/Pet-Formulario.vue'),
      'RF-Compra-Etiqueta': () => import('@/components/compra/etiqueta/Compra-Etiqueta.vue'),
      'RF-Formulario-Produto': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario.vue'),
      'RF-Formulario-Servico': () => import('@/components/servico/gerenciar/RF-Serv-Form.vue'),
      'RF-Formulario-Sit-Fiscal': () => import('@/components/servico/sit-fiscal/RF-Sit-Fiscal-Form.vue'),
      'RF-Formulario-Controle-Processo': () => import('@/components/controle-processo/painel/RF-Controle-Processos-Form.vue'),
      'RF-Formulario-Comssisao': () => import('@/components/comissoes/Comissoes-Editar.vue'),
      'RF-DF-Abrir': () => import('@/components/_geral/DF-Abrir.vue'),
      'RF-DF-Reenviar': () => import('@/components/_geral/DF-Reenviar.vue'),
      'RF-Buscar-Cadastro': () => import('@/components/rf-geral/visualizar/Buscar-Cadastro.vue'),
      'RF-Subase-Gerenciar-Clu': () => import('@/components/subase/gerenciar/Subase-Gerenciar-Clu.vue'),
      'RF-Subase-Gerenciar-Informacoes-Clu': () => import('@/components/subase/gerenciar/Subase-Gerenciar-Informacoes-Clu.vue'),
      'RF-Financeiro-Editar-Boleto': () => import('@/components/financeiro/Financeiro-Editar-Boleto.vue'),
      'App-Conta-Bancaria-Dialog-Conciliados': () => import('@/components/financeiro/Conciliacao/Financeiro-Conciliacao-Bancaria-Dialog-Conciliados.vue'),
      // 'RF-Venda-Insumo-Consumo': () => import('@/components/venda/Venda-Insumo-Consumo.vue'),
      'RF-Usuario-Upload-Imagem': () => import('@/components/usuario/Usuario-Upload-Imagem.vue'),
      'Armazenamento-Arquivos-Anexar': () => import('@/components/armazenamento-arquivos/anexar/Armazenamento-Arquivos-Anexar.vue'),

      'App-Demanda-Nova': () => import('@/components/demanda/Demanda-Nova.vue'),
      'DF-Log': () => import('@/components/_geral/DF-Log.vue'),
      'App-Etiqueta-Itens': () => import('@/components/config/Etiqueta/Etiqueta-Itens.vue'),
      'App-Demanda-Consultar': () => import('@/components/demanda/Demanda-Consultar.vue'),
      'App-Contato-Consultar': () => import('@/components/contato/gerenciar/Contato-Consultar.vue'),
      'App-Produto-Consultar': () => import('@/components/produto/gerenciar/Produto-Consultar.vue'),

      'App-Buscar-Cadastro-Api': () => import('@/components/_geral/Buscar-Cadastro-Api.vue'),
      'App-Sit-Fiscal-Simulador': () => import('@/components/produto/sit-fiscal/Produto-Sit-Fiscal-Simulador.vue'),
      'App-Subase-Suporte': () => import('@/components/subase/Subase-Suporte.vue'),
      'App-Consultar-Historico': () => import('@/components/historico/Consultar-Historico.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: ''
      }
    },
    mounted: function () {
      this.abrirCadastrosIniciar()
    },
    methods: {
      abrirCadastrosIniciar: function () {
        this.time = new Date().getTime()
      },
      abrirCadastrosNaoEncontrado: function (index) {
        // eslint-disable-next-line
        console.error('abrirCadastrosNaoEncontrado', index, this.$store.state.cadastroVet[index])
      },
      abrirCadastrosAlterarIdProduto: function (index, cpntId) {
        this.$store.commit('SET_ALTERAR_CHAVE_CADASTRO_VET', { index: index, chave: 'id', value: cpntId })
      },
      abrirCadastroAtualizarFilhos: function (index) {
        if ([ '', null, undefined ].indexOf(this.$store.state.cadastroVet[index]) === -1 && typeof this.$store.state.cadastroVet[index].callbackAtu === 'function') {
          this.$store.state.cadastroVet[index].callbackAtu()
        }
      }
    },
    watch: {
      cpntQtde: function () {
        this.abrirCadastrosIniciar()
      },
      '$store.state.cadastroVet.time': function () {
        this.abrirCadastrosIniciar()
      }
    }
  }
</script>
